import { createContext } from "react";

export const ContextViewport = createContext<any>({});